require('./brokerPensionPlanInfoView.scss');

// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
// @ commons
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const AppDownloadWidget = require('components/appDownloadWidget/appDownloadWidget');
const { BrokerInvestmentSpecialist } = require('components/broker/brokerInvestmentSpecialist/brokerInvestmentSpecialist');
// @ components
const BrokerPensionPlanInfo = require('components/broker/brokerPensionPlanInfo/brokerPensionPlanInfo');
// @constants
const {
    MYPROFILE_BROKER_URL,
    MYPROFILE_BROKER_PLANS_URL
} = require('constants/index');

class BrokerPensionPlanInfoView extends React.Component {
    constructor(props) {
        super(props);
        this.handleGoToWalletClick = this.handleGoToWalletClick.bind(this);
    }

    handleGoToWalletClick() {
        this.props.history.push(MYPROFILE_BROKER_URL);
    }

    render() {
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-pensionPlan'),
                url: MYPROFILE_BROKER_PLANS_URL
            },
            {
                text: formatText('pensionPlanInfo-contribution')
            }
        ];

        return (
            <section className="broker-pension-plan-info-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={mappingBreadcrumb}
                        finalTitle={getFinalTitle('pensionPlanInfo-title')}
                    >
                        <OKButton
                            inverse={true}
                            modifier="ghost"
                            onClick={this.handleGoToWalletClick}
                        >
                            <FormattedText value="broker-plansInfoButtonLabel" />
                        </OKButton>
                    </OKHeaderSubPage>
                </OKCover>
                <section className="broker-pension-plan-info-view__body">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-8">
                            <BrokerPensionPlanInfo />
                        </div>
                        <div className="col-xs-4">
                            <div className="broker-pension-plan-info-view__content">
                                <BrokerInvestmentSpecialist />
                            </div>
                            <AppDownloadWidget />
                        </div>
                    </div>
                </section>
            </section>
        );
    }
}

BrokerPensionPlanInfoView.propTypes = {
    history: PropTypes.object.isRequired,
}

module.exports.constructor = BrokerPensionPlanInfoView;
module.exports = withRouter(BrokerPensionPlanInfoView);
